
<div [ngClass] = "{'common-dialog-outer-drop' : data.drop==='yes','common-dialog-outer': !data.drop && !data.group, 'common-dialog-group-outer': data.group  }">
  <mat-dialog-actions *ngIf="data.drop">
    <button mat-button mat-dialog-close class="close-botton">X</button>
  </mat-dialog-actions>
  <div class="image-container" *ngIf="!data.selectWarehouse && !data.template && data?.image" >
      <img   class="common-dialog-image" src="../../assets/images/svg/{{data.image}}.svg">
  </div>
  <div class="image-container" *ngIf="!data.selectWarehouse && data.template && data?.image" >
    <img class="common-dialog-image" src="../../assets/images/svg/{{data.image}}.svg">
</div>

  <mat-dialog-content>
    <!-- <h5 class="common-dialog-title">{{data.title}}</h5>
    <p class="common-dialog-content" [ngClass]="{'p-b':!(data.optionLine === undefined)}">{{data.content}}</p>
    <p class="common-dialog-content bld">{{data.optionLine}}</p> -->
    <div class="text-center" [ngClass]="{'custom-align-start': customAlignStart}">
      <ng-container *ngIf="data.asHtml; else notHtmlTitleBlock;" >
        <h5 [innerHTML]="data.title"></h5>
      </ng-container>
      <ng-template #notHtmlTitleBlock>
        <h5 >{{data.title}}</h5>
      </ng-template>
      <div class="subtitle" [innerHTML]="data.subtitle"></div>
      <ng-container *ngIf="data?.type === 'trialFlow'; else nontrialBlock;">
        <div class="d-flex flex-col flex-gap-half px-4" >
          <ng-container *ngFor="let step of data.stepSection">
            <div class="d-flex flex-gap-1 items-center" [ngClass]="{'faded': step.status === 'next'}">
              <div>
                <div *ngIf="step.status === 'done'"><i class="fa fa-check-circle text-success font-13"></i></div>
                <div *ngIf="step.status !== 'done'" class="circle circle-md {{step.colorCss}}" [ngClass]="{'pulse': step?.status === 'current'}"></div>
              </div>
              <div>
                {{step.text}}
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-template #nontrialBlock>
        <ng-container *ngIf="data.asHtml; else nonHTMLContentBlock">
          <p class="p-content dialog-content" [ngClass]="{'pivot-content': (data.pivotCol)}"  [innerHTML]="data.content"></p>
        </ng-container>
        <ng-template #nonHTMLContentBlock>
          <p class="p-content dialog-content" *ngIf="!data?.asHtml ">{{data.content}}</p>
        </ng-template>
      </ng-template>

      <p class="p-op-line1"><a href={{data.documentURL}} target="_blank">{{data.documentName}}</a></p>
      <p class="p-op-line">{{data.optionLine}}</p>
      <mat-form-field *ngIf="data.prompt">
        <mat-label>Password</mat-label>
        <input matInput type="password" [(ngModel)]="data.password">
      </mat-form-field>
    </div>

    <div>
      <mat-selection-list *ngIf="data.columnHashingConfigurationEdited" [(ngModel)]="reloadTableSelection" class="hashing-edited-tables">
        <mat-list-option *ngFor="let tableToReload of data.tablesToReload" [value]="tableToReload" color="primary">
          {{tableToReload}}
        </mat-list-option>
      </mat-selection-list>

      <mat-form-field class="example-full-width" appearance="fill" *ngIf="data.selectWarehouse">
        <mat-label>Search</mat-label>
        <input matInput placeholder="" [(ngModel)]="searchStr" (keyup)="filterWarehouseList()">
      </mat-form-field>

      <mat-selection-list *ngIf="data.selectWarehouse" [multiple]="'false'" [(ngModel)]="selectedWarehouse" class="hashing-edited-tables min-height">


        <mat-list-option *ngFor="let warehouse of warehouseDataset" [value]="warehouse.warehouseId" color="primary" (click)="selectWarehouse()" >

          <div class="d-block"  >

              <img src="../../assets/images/datawarehouselogos/{{warehouse.logoUrl}}.png" alt="" width="30" height="30">
              <span class="label-02 ml-10 ver-sup">{{warehouse.name}} </span>

          </div>



        </mat-list-option>
        <div *ngIf="warehouseDataset.length === 0"> No destination matches with this search. </div>
      </mat-selection-list>
    </div>

    <div *ngIf="data.group && (data.group === 'create' || data.group === 'edit')">
      <form #groupForm="ngForm">
        <mat-form-field class="example-full-width" appearance="outline" *ngIf="data.group">
          <mat-label>Group name</mat-label>
          <input matInput placeholder="Group name" (keyup)="onGroupFormChange($event, groupName)" name="groupName" required maxlength="51" minlength="1" pattern="^[a-zA-Z0-9\s]+$" [(ngModel)]="groupData.groupName" #groupName="ngModel" >
          <mat-error *ngIf="groupName.invalid && (groupName.dirty || groupName.touched) && groupName.errors?.required">Group name is required</mat-error>
          <mat-error *ngIf="groupName.invalid && (groupName.dirty || groupName.touched) && groupName.errors?.minlength">Group name must be at least 1 character long</mat-error>
          <mat-error *ngIf="groupName.invalid && (groupName.dirty || groupName.touched) && groupName.errors?.maxLength">Group name should not be more than 50 characters</mat-error>
          <mat-error *ngIf="groupName.invalid && (groupName.dirty || groupName.touched) && groupName.errors?.pattern">Group name should contain only alphanumerics characters</mat-error>
          <mat-error *ngIf="groupName.invalid && (groupName.dirty || groupName.touched) && groupName.errors?.companyName">Group name should not be the same as company name</mat-error>

        </mat-form-field>
        <mat-form-field class="example-full-width" appearance="outline" *ngIf="data.group">
          <mat-label>Description</mat-label>
          <textarea matInput placeholder="Group Description" name="groupDescription" maxlength="150" [(ngModel)]="groupData.groupDescription"></textarea>
        </mat-form-field>
      </form>
    </div>

    <ng-container *ngIf="data.template && (data.templateMode === 'edit')">
      <div class="d-flex flex-gap-1 flex-col mb-2">
        <label class="label-radio font-weight-bold font-18 h-100 border-bottom">Now
          <p class="font-15 text-black">by choosing this option associated integrations will automatically update.</p>
          <input type="radio"
            [(ngModel)]="applyTemplateChanges"
            (change)="applyTemplateChangeHandler($event)"
            value="now" name="applyTemplateChanges">
            <span class="checkmark"></span>
        </label>

        <label class="label-radio font-weight-bold font-18 h-100">Later
          <p class="font-15 text-black">Save your changes as a draft and apply them later in the template screen.</p>
          <input type="radio"
            [(ngModel)]="applyTemplateChanges"
            (change)="applyTemplateChangeHandler($event)"
            value="later" name="applyTemplateChanges">
            <span class="checkmark"></span>
        </label>
      </div>
    </ng-container>
  </mat-dialog-content>

  <div *ngIf="data.drop !== 'yes' && data.template && data.templateMode === 'edit'">
    <div class="block-container">
      <ng-container *ngFor="let buttonData of data.buttons">
        <button mat-stroked-button *ngIf="buttonData.type === 'no-change'" color="primary"
          class="btn-block mb-2 mar-button-10" (click)="onApplyTemplateChangeClose(buttonData)">{{buttonData.title}}
        </button>
        <button mat-flat-button [disabled]="buttonData.type === 'disabled' || disableApplyTemplateChangeButton"
          *ngIf="buttonData.type !== 'no-change'" color="primary" class="btn-block mb-2 mar-button-10"
          (click)="onApplyTemplateChangeClose(buttonData)">{{buttonData.title}}
        </button>
        <!-- <img *ngIf="buttonData.icon" [src]="buttonData.icon" alt="arrow" class="icon-inline" /> -->
      </ng-container>
    </div>
  </div>

  <div *ngIf="data.drop !== 'yes' && data.group">
    <div class="block-container">
      <ng-container *ngFor="let buttonData of data.buttons">
        <button mat-stroked-button *ngIf="buttonData.type === 'no-change'" color="primary"
          class="btn-block mb-2 mar-button-10" (click)="onClose(buttonData)">{{buttonData.title}}
        </button>
        <button mat-flat-button [disabled]="buttonData.type === 'disabled' || disableGroupFormSubmit"
          *ngIf="buttonData.type !== 'no-change'" color="primary" class="btn-block mb-2 mar-button-10"
          (click)="onClose(buttonData, data.password)">{{buttonData.title}}
        </button>
      </ng-container>
    </div>
  </div>

  <div *ngIf="data.steps">
    <div class="steps-action-container">
      <ng-container *ngFor="let buttonData of data.buttons">
        <button mat-stroked-button *ngIf="buttonData.type === 'cancel'"
          class="btn-block mb-2 mar-button-10" (click)="onClose(buttonData)">{{buttonData.title}}
        </button>
        <button mat-flat-button [disabled]="buttonData.type === 'disabled'"
          *ngIf="buttonData.type !== 'cancel'" color="primary" class="btn-block mb-2 mar-button-10"
          (click)="onClose(buttonData, data.password)">{{buttonData.title}}
        </button>
      </ng-container>
    </div>
  </div>



  <!-- <mat-dialog-actions align="center" class="common-dialog-buttons-wrapper"> -->
    <div *ngIf="data.drop !== 'yes' && data.dropRow !== 'yes' && !data.group && !data.template && !data.steps">
        <!-- <button  *ngFor="let buttonData of data.buttons"  class="{{buttonData.class}}" (click)="onClose(buttonData)">{{buttonData.title}}</button> -->
        <div class="block-container flex-gap-2">
          <ng-container *ngFor="let buttonData of data.buttons">

              <button mat-stroked-button *ngIf="buttonData.type === 'no-change'"
              color="primary" class="btn-block {{buttonData.class}}"
            (click)="onClose(buttonData)" [ngClass]="{'pivot-button': (data.pivotCol)}" >{{buttonData.title}}
                      </button>
                      <!-- <img src="assets/images/svg/arrow-right.svg" /> -->

      
              <!-- <button mat-flat-button [disabled]="buttonData.type === 'disabled'" *ngIf="buttonData.type !== 'no-change'"
              color="primary" class="btn-block {{buttonData.class}}"
            (click)="onClose(buttonData, data.password)" >{{buttonData.title}}
            <img *ngIf="buttonData.icon" [src]="buttonData.icon" alt="arrow" class="icon-inline" />

                      </button> -->
              <button mat-flat-button [disabled]="buttonData.type === 'disabled'" *ngIf="buttonData.type !== 'no-change'" color="primary" class="btn-block {{buttonData.class}}" (click)="onClose(buttonData, data.password)">
                
                <span [ngClass]="{'btn-content-with-icon': buttonData.icon}">
                  {{buttonData.title}}
                  <img *ngIf="buttonData.icon" [src]="buttonData.icon" alt="arrow" class="icon-inline" />
                </span>
              </button>
              


          </ng-container>


        </div>


                  <!-- {{data.buttons | json}} -->
    </div>
    <!-- </mat-dialog-actions>
    [class.mat-stroked-button]="buttonData.type === 'no-change'"
        [class.mat-flat-button]="buttonData.type === 'delete'"-->


    <div *ngIf="data.drop">
        <div class="block-container drop" >
              <button mat-stroked-button color="primary" class="btn-block mb-2 mar-button-0"
                (click)="onClose(data.buttons[0])" >Delete Integration
              </button>

              <p>
                Choosing this option will prevent you from using same integration name in daton
                in the future. Tables in the warehouse will stay as-is.
              </p>

              <button mat-flat-button color="primary" class="btn-block mb-2 mar-button-0"
                (click)="onClose(data.buttons[1])" >Delete integration and Drop tables
              </button>

              <p>
                Choosing this option will allow you to reuse the same integration name in daton
                in the future. Tables created by this integration will be dropped from the warehouse
                and the metadata table entries will be deleted.
              </p>

        </div>
    </div>
    
    <div *ngIf="data.dropRow">
      <div class="block-container">
        <ng-container *ngFor="let buttonData of data.buttons">
          <button mat-stroked-button *ngIf="buttonData.type === 'no-change'" color="primary"
            class="btn-block mb-2 mar-button-10" (click)="onCancel()">{{buttonData.title}}
          </button>
          <button mat-flat-button *ngIf="buttonData.type === 'remove'" color="primary"
            class="btn-block mb-2 mar-button-10" (click)="onConfirm()">{{buttonData.title}}
          </button>
        </ng-container>
      </div>
    </div>
  
    <ng-container *ngIf="data.templateConnectors">
      <div class="mt-1">

        <div class="connectors-container d-flex justify-center flex-gap-1 flex-column">
          <div class="d-flex items-center connectors-search-box">
            <div class="connectors-search-icon"><img src="assets/images/search.svg" alt="search-icon"></div>
            <input type="text" [formControl]="filter" placeholder="Search by source name"
              class="duration-300 Roboto font-weight-light font-16">
          </div>

          <div class="container-item-wrapper">

          <ng-container *ngFor="let connector of connectors$ | async">
            <ng-container *ngIf="connector.template">
                <div class="connector-item d-flex flex-gap-8 items-center" (click)="templateTypeHandler(connector)">
                  <img class="source-logo" src='assets/images/source-logos/pngFormat/{{connector.logoUrl}}' alt="">
                  <p>{{connector.displayName}}</p>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>

      </div>

    </ng-container>
</div>
